<template>
    <div class="news-list">
        <head-top :navActive="navActive"></head-top>
        <!-- 内容 start -->
        <div class="news-list-box">
            <div class="news-list-main">
                <list-left @leftClick="leftClick"></list-left>
                <div class="news-list-main-right">
                    <div class="report-download-title">
                        <i></i>
                        <p>{{headTitle}}</p>
                    </div>
                    <div class="list-detail-inner">
                        <h2>{{newsData.title}}</h2>
                        <h3>时间：{{newsData.created_at}} 编辑：{{newsData.author}} 阅读：{{newsData.num}}次</h3>
                        <div class="list-detail-inner-content" v-html=newsData.content></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 内容 end -->
        <foot-bottom></foot-bottom>
    </div>
</template>

<script>
    import headTop from '../components/header/head-top'
    import footBottom from '../components/footer/foot-bottom'
    import listLeft from '../components/news-list-left/new-list-left'
    import tool from '@/assets/js/tool.js'
    export default {
        name: "news-list",
        data() {
            return {
                navActive: 4,
                newsData:{},
                title:'',
                headTitle:this.$route.query.title
            }
        },
        mounted() {
            this.getData();
            this.listFn(1,this.$route.query.id);
        },
        components: {
            headTop,
            listLeft,
            footBottom,
        },
        methods: {
          listFn(page,Id){
            let data={
              information_category_id:Id,
              page:page,
              page_size:22,
            };
              tool.postData('get_info_list',data,(res) => {
                let category = res.data.data.category_two;
                this.title = category.name
              })
          },
            leftClick(val){
                let data={
                    id:val
                };
                tool.postData('get_information_detail',data,(res) => {
                    this.newsData =res.data.data.detail||{};
                });
            },
            getData() {
                let data={
                    id:this.$route.query.Nid
                };
                tool.postData('get_information_detail',data,(res) => {
                    this.newsData =res.data.data.detail||{};
                    console.log(this.newsData);
                });
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../assets/style/common";

    .news-list {
        width: 100%;
        height: 100%;
        background-color: #eff4ff;
    }

    .news-list-box {
        width: 100%;
        background: url("../../static/img/nav.png") no-repeat top center;
        padding-top: 80px;
        box-sizing: border-box;
        margin-bottom: 60px;
        .news-list-main {
            width: $box-width;
            @include flex($align: flex-start);
            margin: 0 auto;
            .news-list-main-right {
                width: 892px;
                min-height: 1484px;
                background-color: #fff;
                padding: 0 26px;
                box-sizing: border-box;
                .report-download-title {
                    width: 100%;
                    height: 94px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #c4d2f4;
                    i {
                        width: 10px;
                        height: 10px;
                        background-color: #3b6bda;
                        margin-right: 10px;
                    }
                    p {
                        @include font(25px, #333);
                        margin-right: 20px;
                        font-weight: bold;
                    }
                    span {
                        @include font(20px, #666)
                    }
                }
            }
        }
    }

    .list-detail-inner {
        padding-top: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #c4d2f4;
        padding-bottom: 28px;
        h2 {
            @include font(26px, #333);
            line-height: 46px;
        }
        h3 {
            @include font(18px, #999);
            line-height: 26px;
        }
        .list-detail-inner-content{
            margin-top: 50px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/news-list-detail.vue